import { render, staticRenderFns } from "./BatchHistory.vue?vue&type=template&id=1f17dee1&scoped=true&"
import script from "./BatchHistory.vue?vue&type=script&lang=ts&"
export * from "./BatchHistory.vue?vue&type=script&lang=ts&"
import style0 from "./BatchHistory.vue?vue&type=style&index=0&id=1f17dee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f17dee1",
  null
  
)

export default component.exports